import { h, FunctionComponent } from 'preact';
import { Trans } from "@lingui/react/macro";
import { LeaderboardEntry } from '../../../services/slot-tournaments';

interface LeaderboardDisplayProps {
    leaderboard: LeaderboardEntry[];
}

export const LeaderboardDisplay: FunctionComponent<LeaderboardDisplayProps> = ({ leaderboard }) => {
    if (leaderboard.length === 0) {
        // Render a message if the leaderboard is empty (and parent isn't loading/error)
        return <p class="text-center text-gray-500 mt-6"><Trans>Leaderboard is currently empty.</Trans></p>;
    }

    return (
        <div class="bg-gray-800 rounded-lg shadow-lg p-6">
            <h3 class="text-xl font-bold text-white mb-4"><Trans>Leaderboard</Trans></h3>
            <div class="overflow-x-auto">
                <table class="min-w-full table-auto text-left text-sm">
                    <thead>
                        <tr class="border-b border-gray-600 text-gray-400">
                            <th class="px-4 py-2"><Trans>Rank</Trans></th>
                            <th class="px-4 py-2"><Trans>Username</Trans></th>
                            <th class="px-4 py-2 text-right"><Trans>Score</Trans></th>
                        </tr>
                    </thead>
                    <tbody class="text-white">
                        {leaderboard.map((entry: LeaderboardEntry) => (
                            <tr
                                class={`border-b border-gray-700 ${entry.is_current_user ? 'bg-yellow-700/30 font-bold' : 'hover:bg-gray-700'}`}
                            >
                                <td class="px-4 py-2">{entry.rank}</td>
                                <td class="px-4 py-2">{entry.username}</td>
                                <td class="px-4 py-2 text-right">{entry.score}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};